<template>
    <div>
        <label for="housing_type" :class="['form-label', { 'form-required': isRequired }]">
            {{ $t("Housing Type") }}
            <span v-if="isRequired" class="required-marker">*</span>
        </label>

        <multi-select
            id="housing_type"
            v-model="selectedHousingType"
            label="name"
            track-by="id"
            :placeholder="$t('-- Select --')"
            :options="housingTypesOpts"
            :select-label="$t('Select')"
            :selected-label="$t('Selected')"
            :deselect-label="$t('Remove')"
            :required="isRequired"
        >
            <template v-slot:noResult>{{ $t('No results found') }}</template>
            <template v-slot:noOptions>{{ $t('List is empty') }}</template>
        </multi-select>

        <input-error :messages="errors?.housing_type" />
    </div>

    <div v-if="selectedHousingType?.id == rentalTypeId">
        <label for="rent_amount"> {{ $t("Rent Amount") }}</label>
        <input id="rent_amount" name="rent_amount" type="number" :value="defaultValue?.rent_amount" required/>
        <input-error :messages="errors?.rent_amount" />
    </div>
    <input v-else type="hidden" name="rent_amount" value=""/>
    <input type="hidden" name="housing_type" :value="selectedHousingType?.id" />

</template>
<script setup>

import { ref, onMounted, onUnmounted } from "vue";

import InputError from "@/components/InputError.vue";
import MultiSelect from "vue-multiselect";

const { housingTypes, defaultValue } = defineProps({
    housingTypes: {
        type: Array,
        required: true
    },
    errors: {
        type: Object,
        default: () => ({})
    },
    rentalTypeId: {
        type: String,
        default: null
    },
    defaultValue: {
        type: Object,
    },
});


const selectedHousingType = ref(null);
const housingTypesOpts = ref(Object.entries(housingTypes).map(([key, value]) => ({
    id: key,
    name: value
})));
const isRequired = ref(true);

const handleEntityTypeChange = (event) => {
    isRequired.value = !event.detail.isCompany;
};

onMounted(() => {
    if (defaultValue?.housing_type) {
        const defaultHousingType = housingTypesOpts.value.find(
            type => type.id == defaultValue.housing_type
        );

        selectedHousingType.value = defaultHousingType;
    }

    window.addEventListener("entity-type-changed", handleEntityTypeChange);
});

onUnmounted(() => {
    window.removeEventListener("entity-type-changed", handleEntityTypeChange);
});

</script>
